module.exports = __webpack_public_path__ + "img/schoolLogo.cbf6e838.png";